<template>
<div class="chapter">
<div class="inner_page">
<p class="toc">C<span class="small">ONTENTS</span></p>
<p class="toc1"><a href="#/ack">Acknowledgements</a></p>
<p class="toc1"><a href="#/introduction">Introduction</a></p>
<p class="toc2"><a href="#/chapter1">1. Who Discovered Fire Island?</a></p>
<p class="toc1"><span href="#/chapter2" title="Link target outside of Sample">2. How Fire Island Got Its Name</span></p>
<p class="toc1"><span href="#/chapter3" title="Link target outside of Sample">3. Captain Kidd’s Fire Island Treasure</span></p>
<p class="toc1"><span href="#/chapter4" title="Link target outside of Sample">4. The Royal Fishes</span></p>
<p class="toc1"><span href="#/chapter5" title="Link target outside of Sample">5. West Sayville’s Widow Molly Inn</span></p>
<p class="toc1"><span href="#/chapter6" title="Link target outside of Sample">6. The First Purple Heart</span></p>
<p class="toc1"><span href="#/chapter7" title="Link target outside of Sample">7. The Truth About Fire Island Pirate Jeremiah Smith</span></p>
<p class="toc1"><span href="#/chapter8" title="Link target outside of Sample">8. The Mystery at Old Inlet</span></p>
<p class="toc1"><span href="#/chapter9" title="Link target outside of Sample">9. The Sumpwams Creek Incident</span></p>
<p class="toc1"><span href="#/chapter10" title="Link target outside of Sample">10. The Memory of Margaret Fuller</span></p>
<p class="toc1"><span href="#/chapter11" title="Link target outside of Sample">11. Call Him Ishmael</span></p>
<p class="toc1"><span href="#/chapter12" title="Link target outside of Sample">12. The Face in the Rigging</span></p>
<p class="toc1"><span href="#/chapter13" title="Link target outside of Sample">13. Fire Island’s Splinter Fleet Navy Heroes</span></p>
<p class="toc1"><span href="#/chapter14" title="Link target outside of Sample">14. Bay Shore and Its Near-Forgotten Heroes</span></p>
<p class="toc1"><span href="#/chapter15" title="Link target outside of Sample">15. USS <i>Northern Pacific</i> and the Heroes of Fire Island</span></p>
<p class="toc1"><span href="#/chapter16" title="Link target outside of Sample">16. Fire Island’s Flying Santa</span></p>
<p class="toc2"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc1"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?4a8cfdaf